module.exports = __webpack_public_path__ + "static/media/2.e6d613b5.jpg";